import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const FeaturesPage = lazy(() => import('../pages/features/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignUpPage = lazy(() => import('../pages/signup/page'));
const AuthCallbackPage = lazy(() => import('../pages/auth/callback/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const NewReportPage = lazy(() => import('../pages/dashboard/new-report/page'));
const SavedReportsPage = lazy(() => import('../pages/dashboard/saved-reports/page'));
const TemplatesPage = lazy(() => import('../pages/dashboard/templates/page'));
const SettingsPage = lazy(() => import('../pages/dashboard/settings/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/features',
    element: <FeaturesPage />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
  },
  {
    path: '/auth/callback',
    element: <AuthCallbackPage />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/new-report',
    element: (
      <ProtectedRoute>
        <NewReportPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/saved-reports',
    element: (
      <ProtectedRoute>
        <SavedReportsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/templates',
    element: (
      <ProtectedRoute>
        <TemplatesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/settings',
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;